import React from 'react';
import { components } from 'react-select';

const DropdownIndicator = (props: components.DropdownIndicator) => {
	return (
		<components.DropdownIndicator {...props}>
			{props.isDisabled ? (
				<img src="/images/chevronDownDisabled.svg" />
			) : (
				<img src="/images/chevronDown.svg" />
			)}
		</components.DropdownIndicator>
	);
};

export default DropdownIndicator;
